<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
       <div
              class="text-center mt-5"
              v-if="terminoCondicionesBase64 === null"
            >
              <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      <iframe :src="terminoCondicionesBase64" frameborder="0" height="400%" 
        width="100%" 
        style="height: 100vh;"
        onload="document.getElementById('loadImg').style.display='none';">
         </iframe>
  </div>
</template>

<script>
import { LoginService } from "@/apiServices/login/LoginService";
export default {
  name: "terminosCondiciones",
  data: () => ({
    loginService: new LoginService(),
    terminoCondicionesBase64: null,
    headers:null,
    idAvisoSistema: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  this.idAvisoSistema = this.$route.params.idAvisoSistema;
  this.generarToken();
  },
  methods: {
     obtenerAvisoTerminosCondiciones() {
       const params = {
         idAvisoSistema: this.idAvisoSistema
       }
      const url = this.$api + "erp/obtenerAvisoSistema";
      this.$http
        .post(url, params, { headers: { Authorization: this.headers } })
        .then((response) => {
          if(response.data.data !== null){
            this.terminoCondicionesBase64 = "data:application/pdf;base64, "+response.data.data;
           }
         })
         .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          });
     },
    generarToken() {
      this.loginService
        .login(
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_USER,
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_DATO
        )
        .then((response) => {
          this.headers = response.Authentication;
          this.obtenerAvisoTerminosCondiciones();
        });
    },
  },
};
</script>

<style>
</style>